import { DataSample } from './data-sample.js'
import { DataSampleQuery } from './data-sample-query.js'
import { DataSampleMutation } from './data-sample-mutation.js'

export const entities = [DataSample]
export const resolvers = [DataSampleQuery, DataSampleMutation]
